import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const ComponentWrapper = styled(Wrapper)`
  margin: 48px 0;
  max-width: 773px;
`;

export const HeadWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const Image = styled.img`
  width: 220px;
  user-select: none;
`;

export const IconCircle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 50%;
    height: 32px;
    width: 32px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.description};
    margin: 8px 0 0 0;
    max-width: 657px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    align-self: end;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-top: 40px;
    width: 100%;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      align-items: center;
      gap: 16px;
      button:first-child {
        order: 2
      }
    }
  `}
`;

export const Agreed = styled.div`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.family.regular};
    margin: 24px 0 0 0;
  `}
`;

export const CheckboxLabel = styled.label`
  ${({ theme }) => css`
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    margin: 0px 0px 4px;

    button {
      padding: 0px 8px 0px 0px;
    }

    label {
      border-radius: 4px;
      svg {
        fill: ${theme.v2.colors.neutral.highPure};
        stroke: ${theme.v2.colors.neutral.highPure};
      }
    }
    input:checked ~ label {
      background-color: ${theme.v2.colors.brand.primaryMedium};
      border-color: ${theme.v2.colors.brand.primaryMedium} !important;
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-items: start;
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ButtonWrapperAdapter = styled.div`
  ${({ theme }) => css`
    button:disabled {
      svg {
        fill: none;
      }
    }
    path {
      stroke-width: 4px;
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const AdviseWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 8px;
    display: flex;
    gap: 48px;
    margin: 24px 0 0 0;
    padding: 40px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      gap: 16px;
      padding: 16px;
    }
  `}
`;

export const SnappyWrapper = styled.div``;

export const SnappyImage = styled.img``;

export const AdviseText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.description};
    text-align: left;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;
